import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-notification-tile _pos-r _bgc--white gfu-background-swept _ai-c" }
const _hoisted_2 = { class: "_flexcol _gap-1 _grow-1" }
const _hoisted_3 = { class: "_flex _jc-sb" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_skeleton_image = _resolveComponent("skeleton-image")
  const _component_skeleton_line = _resolveComponent("skeleton-line")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_skeleton_image, { size: 80 }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_skeleton_line, {
          height: 10,
          class: "_flex-basis-60"
        }),
        _createVNode(_component_skeleton_line, {
          height: 10,
          class: "_flex-basis-33"
        })
      ]),
      _createVNode(_component_skeleton_line, { height: 11 }),
      _createVNode(_component_skeleton_line, { height: 11 }),
      _createVNode(_component_skeleton_line, { height: 12 }),
      _createVNode(_component_skeleton_line, { height: 12 })
    ])
  ]))
}